import React from "react";
import { postRequest } from "./QuoteApiService";

export const getItemsSearch = (rec) => {
  return new Promise((resolve, reject) => {
    try {
      // do an SDK, DB call or API endpoint axios call here and return the promise.
      postRequest('GetItemsSearch/', rec)
      .then((res) => {
        console.log("GetItemsSearch > axios res=", res);
        //const persons = res.data;
        resolve(res.data);
      })
      .catch((err) => {
        console.log("GetItemsSearch > axios err=", err);
        reject("Error in GetItemsSearch axios!");
      });
    } catch (error) {
      console.error("in services > GetItemsSearch, Err===", error);
      //reject(SYSTEM_ERROR);
    }
  });
  
}